import React, { useState, useEffect } from 'react';
import {  
  Container, 
  Typography, 
  Box, Grid, 
  CssBaseline, 
  Toolbar, 
  AppBar, 
  CircularProgress} from '@mui/material';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import DrawerMenu from '../Shared/DrawerMenu';
import { config, logoURL } from '../../../config/settings.jsx';
import { getTheme } from '../../../config/theme';
import { api } from '../../../config/apis.jsx';


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  };
  const truncateAndCleanDescription = (description, maxLength) => {
    // Use regex to remove everything before the date and truncate to maxLength
    const cleanedDescription = description.replace(/^.*?\d{2}\/\d{2} /, '');
    if (cleanedDescription.length > maxLength) {
      return `${cleanedDescription.substring(0, maxLength)}...`;
    }
    return cleanedDescription;
  };

const History = () => {
  const cdrid = localStorage.getItem('cdrid');
  const [sortedRoundUphistory, setSortedRoundUpHistory] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [assetsPath, setAssetsPath] = useState('');

 

  useEffect(() => {
      const getRoundUpHistory = async () => {
        setIsLoadingData(true);
      try {
        const response = await axios.post(
          api.retrieveHistory,
          { cdrid },
          { headers: { 'Content-Type': 'application/json',
        apikey: config.apikey,
            tenant: config.tenant
           } }
        );
        const roundUpHistory = sortDebitsByDate(response.data.roundUphistory.documents);
        setSortedRoundUpHistory(roundUpHistory);
        console.log(response)
      }  catch (error) {
        console.error('failed to retrieve total payments', error);
      } finally {
        setIsLoadingData(false);
      }
    };
        

    if (cdrid) {
      getRoundUpHistory();
  
    }
  }, [cdrid]);
 
  const sortDebitsByDate = (debits) => {
    return debits.sort((a, b) => {
      const aDate = new Date(a.createdDate);
      const bDate = new Date(b.createdDate);
      return bDate - aDate; // Sort in descending order
    });
  };

return (
    <ThemeProvider theme={getTheme}>
    <CssBaseline>
    <Container component="primary" maxWidth="xs"> 
    <AppBar position="static" color="appbar" elevation={0}>
          <Toolbar>
            <DrawerMenu />
            <Typography variant="body" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
              Round-Up History
            </Typography>
          </Toolbar>
        </AppBar></Container>
        <Container component="secondary" maxWidth="xs"> 

  
        <Grid item xs={12} justifyContent="center" height={3}>
    </Grid>
    <Box display="flex" flexDirection="column" alignItems="center" bgcolor="#F9F9F7" mt={2} p={2} borderRadius='12px' >
        <Grid container justifyContent="center" mb={2}>
            <Grid item xs={12} justifyContent="center">
                <Box display="flex" justifyContent="center" >
                    <img src={logoURL} alt="Logo"  style={{ width: '60%', height: 'auto'}} />
                </Box>
            </Grid>
        </Grid>
     
    </Box>


   

    


    <Box display="flex" flexDirection="column" alignItems="left" bgcolor="#F9F9F7" mt={2} p={2} borderRadius='12px'>
  <Grid container alignItems="left">
    <Box display="flex" alignItems="left" width="100%" mt='10px'>
      <Grid item xs={2}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
          Date
        </Typography>
      </Grid>
      <Grid item xs={5}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
          Description
        </Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'right', whiteSpace: 'nowrap' }}>
          Amount
        </Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'right', whiteSpace: 'nowrap' }}>
          Roundup
        </Typography>
      </Grid>
    </Box>
  </Grid>
  {isLoadingData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', mt: 5, mb: 5  }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
  
  {sortedRoundUphistory.map((debit, index) => (
    <Box key={index} display="flex" justifyContent="space-between" alignItems="center" width="100%" mt='10px'>
      <Typography variant="caption" sx={{ textAlign: 'left', flexGrow: 0, mr: 2, whiteSpace: 'nowrap' }}>
        {formatDate(debit.createdDate)}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'left', flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {truncateAndCleanDescription(debit.description, 50)}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'right', flexGrow: 0, whiteSpace: 'nowrap' }}>
        ${debit.amount}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'right', flexGrow: 0, ml: 2, color: 'darkgreen', whiteSpace: 'nowrap' }}>
        ${((debit.debitAmountCents / 100).toFixed(2))}
      </Typography>
    </Box>
  ))} </>)}
</Box>

    <Grid item xs={12} justifyContent="center" height={30}>
    </Grid>
    </Container>
            </CssBaseline>
            </ThemeProvider>
       
  );

}
export default History;

export {};